import React from 'react';

/**
 * HorizontalScrollMobile Component
 * Makes card sections scroll horizontally on mobile devices
 * Desktop: Shows normal grid layout
 * Mobile: Shows horizontal scrolling with snap points
 */
const HorizontalScrollMobile = ({ children, className = '', desktopCols = 'md:grid-cols-3' }) => {
  return (
    <>
      {/* Desktop Grid View */}
      <div className={`hidden md:grid ${desktopCols} gap-8 ${className}`}>
        {children}
      </div>

      {/* Mobile Horizontal Scroll */}
      <div className="md:hidden overflow-x-auto scrollbar-hide -mx-4 px-4">
        <div className="flex gap-4 pb-4" style={{ scrollSnapType: 'x mandatory' }}>
          {React.Children.map(children, (child, index) => (
            <div 
              key={index}
              className="flex-shrink-0 w-[85vw] max-w-sm"
              style={{ scrollSnapAlign: 'start' }}
            >
              {child}
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </>
  );
};

export default HorizontalScrollMobile;
